import UpdateAccount from './UpdateAccount'
export default UpdateAccount
